import { ref, computed } from "vue"
import { defineStore } from "pinia"

const useLocationStore = defineStore({
	id: "location",
	state: () => ({
		selected: null,
		list: [],
	}),
	actions: {
		set(key, value) {
			this[key] = value
		},
	},
	persist: true,
})

export { useLocationStore }
